// Rotulos de eixo Y que continuam legiveis quando a curva varia pouco em torno de um
// valor grande. A frequencia ressonante vive na casa dos 7 a 11 MILHOES de Hz, mas um
// ensaio inteiro mexe so alguns milhares de Hz: com um numero fixo de casas, toda marca
// do eixo vira "11,25 mi". Aqui as casas saem da FAIXA dos dados do eixo — o bastante
// para duas marcas vizinhas nunca terem o mesmo texto.

const MARCAS_APROXIMADAS = 5; // o ECharts desenha ~5 divisoes num eixo de valor
const MAX_CASAS = 4;

const UNIDADES = [
    { limite: 1e6, divisor: 1e6, sufixo: ' mi' },
    { limite: 1e3, divisor: 1e3, sufixo: ' mil' },
];

/** Menor e maior valor numerico das series (cada ponto e [x, y]). */
export function extensaoDosValores(series) {
    let min = Infinity;
    let max = -Infinity;
    for (const s of series || []) {
        for (const ponto of s?.data || []) {
            const v = Array.isArray(ponto) ? ponto[1] : ponto;
            if (typeof v !== 'number' || !Number.isFinite(v)) continue;
            if (v < min) min = v;
            if (v > max) max = v;
        }
    }
    return Number.isFinite(min) ? { min, max } : null;
}

/**
 * Formatador para os rotulos de um eixo cuja extensao de dados e `extensao`.
 * Abaixo de mil: numero normal (ate 2 casas), como sempre foi — temperatura e contagem
 * de sensor nao mudam. A partir de mil: "mil"/"mi" com quantas casas a faixa pedir.
 */
export function criarFormatadorEixo(extensao) {
    const maiorAbsoluto = extensao ? Math.max(Math.abs(extensao.min), Math.abs(extensao.max)) : 0;
    const unidade = UNIDADES.find((u) => maiorAbsoluto >= u.limite);

    if (!unidade) {
        const fmt = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });
        return (valor) => (valor == null || Number.isNaN(valor) ? '' : fmt.format(valor));
    }

    const amplitude = extensao.max - extensao.min;
    const passo = amplitude > 0 ? amplitude / MARCAS_APROXIMADAS / unidade.divisor : 0;
    const casas = passo > 0 ? Math.min(MAX_CASAS, Math.max(0, Math.ceil(-Math.log10(passo)))) : 2;
    const fmt = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
    });
    return (valor) =>
        valor == null || Number.isNaN(valor) ? '' : `${fmt.format(valor / unidade.divisor)}${unidade.sufixo}`;
}
